import PropTypes from 'prop-types'
import React from 'react'
import { Button, BUTTON_SIZE_SM } from '../Button'

import classnames from 'classnames'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import {
  faBars,
  faCheck,
  faXmark,
  faPause,
  faPlay,
  faPlus,
} from 'mailup-fontawesome-kit/classic/solid'
import {
  faTrashCan,
  faPencil,
  faMagnifyingGlass,
} from 'mailup-fontawesome-kit/classic/regular'

import styled from '@emotion/styled'

export const ACTION_BUTTON_TYPE_ACTIONS = 'actions'
export const ACTION_BUTTON_TYPE_DELETE = 'delete'
export const ACTION_BUTTON_TYPE_CANCEL = 'cancel'
export const ACTION_BUTTON_TYPE_DETAILS = 'details'
export const ACTION_BUTTON_TYPE_EDIT = 'edit'
export const ACTION_BUTTON_TYPE_ADD = 'add'
export const ACTION_BUTTON_TYPE_SELECT = 'select'
export const ACTION_BUTTON_TYPE_PAUSE = 'pause'
export const ACTION_BUTTON_TYPE_PLAY = 'play'

const StyledButton = styled(Button)`
  padding: 0;
  width: 28px;
  height: 28px;
  vertical-align: middle;
  display: flex;
  justify-content: center;
  align-items: center;
  span {
    position: relative;
    top: 1px;
  }

  border-color: ${(props) => (props.disabled ? '#aaaaaa' : '#252525')};
  color: ${(props) =>
    props.disabled
      ? props.kind === 'primary'
        ? '#ffffff'
        : '#aaaaaa'
      : props.kind === 'primary'
        ? '#ffffff'
        : '#252525'};
  &:hover,
  &:active,
  &:focus {
    border-color: ${(props) =>
      props.disabled
        ? props.kind === 'primary'
          ? '#ffffff'
          : '#aaaaaa'
        : props.kind === 'primary'
          ? '#ffffff'
          : '#1286a4'};
    color: ${(props) =>
      props.disabled
        ? props.kind === 'primary'
          ? '#ffffff'
          : '#aaaaaa'
        : props.kind === 'primary'
          ? '#ffffff'
          : '#1286a4'};
  }
`

export const ButtonAction = ({
  type,
  className,
  disabled,
  tooltip,
  onClick,
  'data-mu-test': dataAttributeTest,
}) => (
  <>
    <StyledButton
      size={BUTTON_SIZE_SM}
      kind={type === ACTION_BUTTON_TYPE_ADD ? 'primary' : 'neutral'}
      disabled={disabled}
      tooltip={tooltip}
      onClick={onClick}
      data-mu-test={classnames(dataAttributeTest)}
      className={className}
    >
      {type === ACTION_BUTTON_TYPE_ACTIONS && (
        <FontAwesomeIcon icon={faBars} disabled={disabled} />
      )}
      {type === ACTION_BUTTON_TYPE_DELETE && (
        <FontAwesomeIcon icon={faTrashCan} disabled={disabled} />
      )}
      {type === ACTION_BUTTON_TYPE_EDIT && (
        <FontAwesomeIcon icon={faPencil} disabled={disabled} />
      )}
      {type === ACTION_BUTTON_TYPE_DETAILS && (
        <FontAwesomeIcon icon={faMagnifyingGlass} disabled={disabled} />
      )}
      {type === ACTION_BUTTON_TYPE_SELECT && (
        <FontAwesomeIcon icon={faCheck} disabled={disabled} />
      )}
      {type === ACTION_BUTTON_TYPE_CANCEL && (
        <FontAwesomeIcon icon={faXmark} disabled={disabled} />
      )}
      {type === ACTION_BUTTON_TYPE_PAUSE && (
        <FontAwesomeIcon icon={faPause} disabled={disabled} />
      )}
      {type === ACTION_BUTTON_TYPE_PLAY && (
        <FontAwesomeIcon icon={faPlay} disabled={disabled} />
      )}
      {type === ACTION_BUTTON_TYPE_ADD && (
        <FontAwesomeIcon icon={faPlus} disabled={disabled} />
      )}
    </StyledButton>
  </>
)

ButtonAction.defaultProps = {
  disabled: false,
}

ButtonAction.propTypes = {
  className: PropTypes.string,
  disabled: PropTypes.bool,
  onClick: PropTypes.func,
  tooltip: PropTypes.string,
  type: PropTypes.oneOf([
    ACTION_BUTTON_TYPE_ACTIONS,
    ACTION_BUTTON_TYPE_DELETE,
    ACTION_BUTTON_TYPE_CANCEL,
    ACTION_BUTTON_TYPE_DETAILS,
    ACTION_BUTTON_TYPE_EDIT,
    ACTION_BUTTON_TYPE_ADD,
    ACTION_BUTTON_TYPE_SELECT,
    ACTION_BUTTON_TYPE_PLAY,
  ]),
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string,
}
